/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useRef, useState } from 'react';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';

import Button, { ButtonContainer } from 'components/Button';
import Icon from 'components/Icon/index';
import Label from 'components/Form/Label';

import { AddButton, TagInput, PlaceHolder } from './styles';

const UploadButton = ({ disabled, idDomainOperation, documentTypeRequired, documentType, multiple, idOperation, onSuccess, isDraft, isInternalDocument, text, hasOsndFlag }) => {
  const mc = new MessageCenter();
  const fitinsur = new FitinsurAPI();

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);

  const fileInputRef = useRef();
  console.log("fileInputRef: ", fileInputRef);

  return (
    <ButtonContainer>
      {hasOsndFlag ? (
        <div style={{ marginBottom: "17px"}}>
        <label htmlFor="fileInput">
          <Icon
          name="importExcel"
          title="Import OSND"
          />
        </label>    
        </div>  
      ) : ( 
        <PlaceHolder htmlFor="fileInput">{text || "UPLOAD FILE"}</PlaceHolder> 
      )}
      <TagInput ref={fileInputRef} id="fileInput" type="file" multiple={multiple} onChange={async (event) => {
        try {
          if (documentTypeRequired && !documentType) throw new Error("Please, specify the document type.");
          if (!event.target.files[0]) throw new Error("Invalid file, please select a valid one.");

          loading.start();
          const { files } = event.target;
          const formData = new FormData();

          for (const file of files) formData.append('files', file)
          formData.append('idOperation', idOperation || "");
          formData.append('idTypeDocument', documentType?.idAnswerOption || "")
          formData.append('dsTypeDocument', documentType?.dsAnswerOption || "")
          formData.append('isDraft', !isDraft ? "" : "true")
          formData.append('isInternalDocument', isInternalDocument || "")

          fitinsur.setAuthToken(authContext.token);
          const response = await fitinsur.requestFileUpload(formData).then(response => response.json());
          if (response.ret_code !== 200) throw new Error(response.ret_msg_details)

          if (fileInputRef?.current) fileInputRef.current.value = null;
          loading.stop();
          onSuccess && onSuccess(response.ret_value)
        } catch (err) {
          if (fileInputRef?.current) fileInputRef.current.value = null;
          console.log('UploadButton - error', err);
          mc.error(err.message);
          loading.stop()
        }
      }} />
    </ButtonContainer>
  );
};


export default UploadButton;
